import React, { useState, useCallback, useEffect } from 'react'
import { notification } from 'antd'
import { HashRouter as Router, Route, Switch, withRouter } from 'react-router-dom'

import { Preview, fromRedactor, VisualPreview, Builder, BuilderLanding } from 'super-charged-rte'

import { Layout, Skeleton } from 'antd'
import { v4 } from 'uuid'

import Sider from './Component/Sider'
import Editor from './Component/Editor'
import * as templates from './template'
import { extractBlocksFromDoc, mergeBlocksIntoDoc, getAllBlocksOfPage, generateNewPage, changePageTitle, deletePage } from './helper'

const generateId = () => v4().split('-').join('')

const { Content } = Layout

const requestInfo = {
  baseUrl: 'https://cdn.contentstack.io/v3',
  assetUrl: 'https://api.contentstack.io/v3',
  apiKey: 'blt2cf669e5016d5e07',
  deliveryToken: 'cs81606189c4e950040a23abe0',
  environment: 'development',
  managementKey: 'csf9e7a0d0e7e9d04e14215f9a'
}

const initialValue = [
  {
    type: 'docs',
    children: [{ type: 'heading-one', children: [{ text: 'Loading...' }] }]
  }
]

const customToolbarComponents = {
  leaf: ['bold', 'italic', 'underline'],
  element: ['paragraph', 'heading-one']
}

const getJsonValue = (html) => {
  const parsedHtml = new DOMParser().parseFromString(
    html,
    'text/html'
  ).body
  let redactorJson = fromRedactor(parsedHtml)
  redactorJson = [
    {
      type: 'docs',
      id: generateId(),
      children: redactorJson
    }
  ]
  return redactorJson
}

const App = (props) => {
  const findUserId = () => {
    let id = null;
    let userIdFromUrl = props.location.pathname.split('/').filter((val) => val)
    if (userIdFromUrl) {
      let x = userIdFromUrl.indexOf('user')
      if (x === -1 || userIdFromUrl.length < x + 1) {
        userIdFromUrl = null
      } else {
        userIdFromUrl = userIdFromUrl[x + 1]
      }
    }
    let userIdFromLocalStorage = localStorage.getItem('scrte-userId')
    if (userIdFromUrl) {
      id = userIdFromUrl
      localStorage.setItem('scrte-userId', id)
    } else if (userIdFromLocalStorage) {
      id = userIdFromLocalStorage
      props.history.push(`/user/${id}`)
    }
    else {
      id = generateId()
      localStorage.setItem('scrte-userId', id)
      props.history.push(`/user/${id}`)
    }
    return id
  }
  const [value, setValue] = useState(initialValue)
  const [isloading, setLoading] = useState(false)
  const [userPages, setPages] = useState([])
  const userProps = { userId: findUserId() }
  const autoSaveProps = {
    manualSaveEnable: true,
    autoSaveEnable: false,
    autoSaveBaseUrl: 'https://domain69.herokuapp.com'
  }
  const changePage = (id) => {
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };
    fetch(`${autoSaveProps.autoSaveBaseUrl}/page/${id}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.page) {

          getAllBlocksOfPage(result.page[0], autoSaveProps.autoSaveBaseUrl).then((val) => {
            setLoading(true)
            val = [val]
            setValue(val)

            localStorage.setItem('seletedPageId', val[0].id)
            setLoading(false)

          }).catch(err => console.log(err))
        }
      })
      .catch(error => console.log('error', error));
  }
  const createNewPage = (pages = userPages) => {
    generateNewPage(userProps, autoSaveProps.autoSaveBaseUrl).then((val) => {

      setPages([...pages, { id: val.allPages[0].id, title: val.allPages[0].title }])
      val.page.then(value => {
        value = [value]
        setLoading(true)
        setValue(value)
        localStorage.setItem('seletedPageId', value[0].id)
        setLoading(false)
      })
    }).catch((err) => {
      console.log(err)
    })
  }
  const changeTitle = (newTitle, id) => {
    changePageTitle(id, newTitle, autoSaveProps.autoSaveBaseUrl).then((val) => {
      let pages = userPages.slice()
      let index = pages.findIndex((val) => val.id === id)
      pages[index].title = newTitle
      setPages(pages)
    }).catch((err) => { console.log(err) })
    return
  }
  const pageDelete = (id) => {
    deletePage(id, autoSaveProps.autoSaveBaseUrl).then((val) => {
      if (val) {
        let pages = userPages.slice()
        pages = pages.filter((val) => val.id !== id)
        setPages(pages)
        if (pages.length !== 0) {
          changePage(pages[0].id)
        } else {
          createNewPage(pages)
        }

      }
    })
  }
  let pageProps = {
    userPages,
    changePage,
    createNewPage,
    changeTitle,
    pageDelete
  }

  useEffect(() => {
    mergeBlocksIntoDoc(userProps, autoSaveProps.autoSaveBaseUrl).then((value) => {
      let allPages = Array.from(value.allPages).map((page) => {
        return {
          id: page._id,
          title: page.title
        }
      })
      setPages(allPages)
      value.page.then((val) => {
        val = [val]
        setLoading(true)

        setValue(val)
        setLoading(false)
      })

    })
  }, [])

  const handleChange = useCallback((newValue) => {
    setValue(newValue)
  }, [])

  const uploadDoc = (event) => {
    event.preventDefault()
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let extractedValue = extractBlocksFromDoc(value[0], userProps)
    let raw = JSON.stringify(extractedValue.docsCollection)


    let requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    let error;
    fetch(`${autoSaveProps.autoSaveBaseUrl}/addPages/`, requestOptions)
      .then(response => {
        let res = response.json()
        if (response.status === 500) {
          error = true
        }
        return res
      })
      .then(result => {

        if (error) {

          notification.open({
            message: 'Error',
            description: result.message,
            type: 'error',
            placement: 'bottomRight'
          })
        }
      })
      .catch(error => {
        console.log('error', error)
      });

    requestOptions.body = JSON.stringify({ blocks: extractedValue.blockCollection })
    fetch(`${autoSaveProps.autoSaveBaseUrl}/addBlocks/`, requestOptions)
      .then(response => {
        let res = response.json()
        if (response.status === 500) {
          error = true
        }
        return res
      })
      .then(result => {

        if (error) {

          notification.open({
            message: 'Error',
            description: result.message,
            type: 'error',
            placement: 'bottomRight'
          })
        }
      })
      .catch(error => {
        console.log('error', error)
      });

  }

  return (
    <Switch>
      <Route exact path='/user/:userId'>
        <Layout>
          <Content style={{ height: '95vh' }}>
            {isloading ? (
              <Skeleton></Skeleton>
            ) : (

                <Editor
                  value={value}
                  contentStack={false}
                  toolbarMode={'advance'}
                  onChange={handleChange}
                  templateRegistryCondition={userProps}
                  isloading={isloading}
                  customTemplates={templates}
                  autoSaveProps={autoSaveProps}

                  {...requestInfo}
                />

              )}
          </Content>
          <Sider value={value} isloading={isloading} uploadDoc={uploadDoc} pageProps={pageProps} />
        </Layout>
      </Route>
      <Route exact path='/user/:userId/preview'>
        <Preview
          value={value}
          style={{ padding: '20px 10px' }}
          templateRegistryCondition={userProps}
          {...requestInfo}
        />
      </Route>
      <Route exact path='/user/:userId/builder'>
        <BuilderLanding />
      </Route>
      <Route path='/user/:userId/builder/visual/:visualPageId/content_types/:uid'>
        <Builder
          value={value}
          contentStack={false}
          toolbarMode={'advance'}
          onChange={handleChange}
          templateRegistryCondition={userProps}
          isloading={isloading}
          customTemplates={templates}
          autoSaveProps={{ manualSaveEnable: false, autoSaveEnable: false }}
        />

      </Route>
      <Route path='/user/:userId/preview/content_types/:uid/entries/:entryId/visual/:visualPageId' >
        <VisualPreview
          value={value}
          style={{ padding: '20px 10px' }}
          templateRegistryCondition={userProps}
          {...requestInfo}
        />
      </Route>
    </Switch>
  )
}
const AppWithRouter = withRouter(App);

const AppContainer = () => {
  return (
    <Router>
      <AppWithRouter />
    </Router>
  );
};

export default AppContainer
